import BaseService from "./BaseService";
import Constants from "../configs/Constants";
import RestAPIHelper from "../common/RestAPIHelper";

export default class AuthenticationService extends BaseService {

    getLogin = (data) => {
        return RestAPIHelper.getSSO(this.getLoginUrl(data.appId, data.redirectUrl, data.renew), null, true);
    };

    doLogin = (data) => {
        return RestAPIHelper.postSSO(Constants.SSO_URL + "/sso-login/login", data, null, true);
    };

    getLoginUrl(appId, redirectUrl, renew) {
        let url = new URL(Constants.SSO_URL + "/sso/login");
        url.searchParams.append('appId', appId);
        url.searchParams.append('redirectUrl', redirectUrl);
        if (renew != null)
            url.searchParams.append('renew', renew);
        return url.href;
    };

    getTokenByCode = (code) => {
        let url = window.globalConfig.ssoBack + '/sso-login/token?code=' + code;
        return RestAPIHelper.get(url);
    };

    //hanx them
    serviceValidate = (token, appId, _callback) => {
        return RestAPIHelper.get(Constants.SSO_URL + "/sso-login/checkPermissionAccess?ticket=" + token + "&appCode=" +appId , _callback);
    };
    //hanx

    logout = (token,_callback) => {
        return RestAPIHelper.get(Constants.SSO_URL + "/sso-login/logout?ticket=" + token, _callback);
    };

    inputAuthenCode =(data, _callback) => {
        return RestAPIHelper.post(Constants.SSO_URL + "/sso-login/authentication2factor" , data , _callback)   ;
    }

    getAllURL = (_callback) => {
        return RestAPIHelper.get(Constants.API_URL + "/app/get_url_all_application", _callback);
    };

    resetPassword = (userName,email, _callback) => {
        return RestAPIHelper.get(Constants.SSO_URL + "/sso-login/resetPassword?userName=" + userName +"&email="+email, _callback);
    }

    changePassword = (data,_callback) =>{
        return RestAPIHelper.post(Constants.API_URL + "/changePassword" , data , _callback)   ;
    }

}
